import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ChangePassword from './pages/ChangePassword';
import AdminDashboard from './pages/AdminDashboard';
import RecruiterDashboard from './pages/RecruiterDashboard';
import FinancialDashboard from './pages/FinancialDashboard';
import Navbar from './components/Navbar';
import { getDashboardPath, canAccessDashboard } from './utils/roleUtils';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        background: 'var(--background-color)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="stat-card-icon" style={{ width: '64px', height: '64px', fontSize: '24px', margin: '0 auto 16px' }}>
            OUK
          </div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="app-layout">
        {user && <Navbar user={user} onLogout={handleLogout} />}
        
        <ToastContainer 
          position="top-right" 
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to={getDashboardPath(user.permissions, user.role)} /> : 
            <Login onLogin={handleLogin} />
          } />
          
          <Route path="/forgot-password" element={
            user ? <Navigate to={getDashboardPath(user.permissions, user.role)} /> : 
            <ForgotPassword />
          } />
          
          <Route path="/reset-password" element={
            user ? <Navigate to={getDashboardPath(user.permissions, user.role)} /> : 
            <ResetPassword />
          } />
          
          <Route path="/change-password" element={
            user ? <ChangePassword user={user} /> : <Navigate to="/login" />
          } />
          
          <Route path="/admin/*" element={
            user && canAccessDashboard(user.permissions, 'admin', user.role) ? <AdminDashboard /> : <Navigate to="/login" />
          } />
          
          <Route path="/recruiter/*" element={
            user && canAccessDashboard(user.permissions, 'recruiter', user.role) ? <RecruiterDashboard /> : <Navigate to="/login" />
          } />
          
          <Route path="/financial/*" element={
            user && canAccessDashboard(user.permissions, 'financial', user.role) ? <FinancialDashboard /> : <Navigate to="/login" />
          } />
          
          <Route path="/" element={
            <Navigate to={user ? getDashboardPath(user.permissions, user.role) : '/login'} />
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
